export enum PedalKind {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}
